import type { TranslationModule } from '../types';

export const lawyerAssistanceTranslations: TranslationModule = {
  ro: {
    seoTitle: "Solicită Asistență Juridică | LegeaAplicată",
    seoDesc: "Conectați-vă cu un specialist juridic din România pentru situația dumneavoastră. Consultanță și asistență juridică personalizată.",
    successTitle: "Cerere Trimisă!",
    successDesc: "Am primit detaliile dumneavoastră. Un specialist va analiza solicitarea și vă va contacta în cel mai scurt timp posibil.",
    btnGoHome: "Înapoi la Pagina Principală",
    heroTitle: "Solicitați Asistență Juridică",
    heroSubtitle: "Completați formularul de mai jos pentru a ne oferi detalii despre situația dvs. Un specialist vă va contacta în cel mai scurt timp posibil.",
    formSectionContact: "Informații de Contact",
    formSectionCase: "Detalii Speță",
    labelName: "Nume și Prenume",
    placeholderName: "Ex: Popescu Ion",
    labelEmail: "Adresă de Email",
    placeholderEmail: "Ex: email@domeniu.ro",
    labelPhone: "Număr de Telefon",
    placeholderPhone: "Ex: 07xxxxxxx",
    labelIsCompany: "Sunt persoană juridică",
    labelIsRepresented: "Sunt deja reprezentat(ă) de un avocat",
    labelCounty: "Județ",
    placeholderCounty: "-- Selectați Județul --",
    descCounty: "Selectați județul relevant pentru cazul dvs.",
    labelPracticeArea: "Aria de practică",
    placeholderPracticeArea: "-- Selectați aria de practică --",
    labelDescription: "Descrieți situația dvs. cât mai în detaliu",
    placeholderDescription: "Scrieți aici detaliile cazului dvs...",
    descDescription: "Oferiți cât mai multe detalii pentru a permite specialiștilor să înțeleagă contextul și să vă ofere o primă evaluare corectă.",
    agreementPart1: "Sunt de acord cu ",
    agreementTermsLink: "Termeni și condiții",
    agreementPart2: " și ",
    agreementPrivacyLink: "Politica cookie și Protecția datelor",
    agreementPart3: ".",
    btnSending: "Se trimite...",
    btnSubmit: "Trimite Cererea",
    valRequiredName: "Numele este obligatoriu",
    valRequiredEmail: "Emailul este obligatoriu",
    valInvalidEmail: "Adresă de email invalidă",
    valRequiredPhone: "Telefonul este obligatoriu",
    valMinPhone: "Minim 10 cifre",
    valRequiredCounty: "Selectați județul",
    valRequiredPracticeArea: "Selectați aria de practică",
    valRequiredDescription: "Descrierea este obligatorie",
    valMinDescription: "Vă rugăm să oferiți mai multe detalii (minim 20 caractere)",
    valRequiredTerms: "Trebuie să fiți de acord cu termenii.",
    errorBannerTitle: "Eroare",
    errorGeneric: "A apărut o eroare la trimiterea cererii. Vă rugăm să încercați din nou.",
    practiceCivil: "Drept Civil",
    practicePenal: "Drept Penal",
    practiceComercial: "Drept Comercial",
    practiceFamiliei: "Dreptul Familiei",
    practiceMuncii: "Dreptul Muncii",
    practiceAdministrativ: "Drept Administrativ",
    practiceFiscal: "Drept Fiscal",
    practiceProprietate: "Dreptul Proprietății Intelectuale",
    practiceInsolventa: "Insolvență",
    practiceImobiliar: "Real Estate",
    practiceBancar: "Drept Bancar",
    practiceAltul: "Altul"
  },
  en: {
    seoTitle: "Request Legal Assistance | LegeaAplicată",
    seoDesc: "Connect with a legal specialist in Romania for your situation. Personalized legal advice and assistance.",
    successTitle: "Request Submitted!",
    successDesc: "We have received your details. A specialist will analyze your request and contact you as soon as possible.",
    btnGoHome: "Back to Home Page",
    heroTitle: "Request Legal Assistance",
    heroSubtitle: "Fill out the form below to provide details about your situation. A specialist will contact you as soon as possible.",
    formSectionContact: "Contact Information",
    formSectionCase: "Case Details",
    labelName: "Full Name",
    placeholderName: "E.g., John Doe",
    labelEmail: "Email Address",
    placeholderEmail: "E.g., email@domain.com",
    labelPhone: "Phone Number",
    placeholderPhone: "E.g., 07xxxxxxx",
    labelIsCompany: "I am a legal entity (company)",
    labelIsRepresented: "I am already represented by a lawyer",
    labelCounty: "County",
    placeholderCounty: "-- Select County --",
    descCounty: "Select the relevant county for your case.",
    labelPracticeArea: "Practice Area",
    placeholderPracticeArea: "-- Select practice area --",
    labelDescription: "Describe your situation in as much detail as possible",
    placeholderDescription: "Write the details of your case here...",
    descDescription: "Provide as many details as possible to allow specialists to understand the context and give you a correct initial evaluation.",
    agreementPart1: "I agree to the ",
    agreementTermsLink: "Terms and Conditions",
    agreementPart2: " and the ",
    agreementPrivacyLink: "Cookies Policy and Data Protection",
    agreementPart3: ".",
    btnSending: "Sending...",
    btnSubmit: "Submit Request",
    valRequiredName: "Name is required",
    valRequiredEmail: "Email is required",
    valInvalidEmail: "Invalid email address",
    valRequiredPhone: "Phone is required",
    valMinPhone: "Minimum 10 digits",
    valRequiredCounty: "Select county",
    valRequiredPracticeArea: "Select practice area",
    valRequiredDescription: "Description is required",
    valMinDescription: "Please provide more details (minimum 20 characters)",
    valRequiredTerms: "You must agree to the terms.",
    errorBannerTitle: "Error",
    errorGeneric: "An error occurred while submitting the request. Please try again.",
    practiceCivil: "Civil Law",
    practicePenal: "Criminal Law",
    practiceComercial: "Commercial Law",
    practiceFamiliei: "Family Law",
    practiceMuncii: "Labor Law",
    practiceAdministrativ: "Administrative Law",
    practiceFiscal: "Tax Law",
    practiceProprietate: "Intellectual Property Law",
    practiceInsolventa: "Insolvency",
    practiceImobiliar: "Real Estate",
    practiceBancar: "Banking Law",
    practiceAltul: "Other"
  },
  fr: {
    seoTitle: "Demander une Assistance Juridique | LegeaAplicată",
    seoDesc: "Connectez-vous avec un spécialiste juridique en Roumanie pour votre situation. Conseils et assistance juridiques personnalisés.",
    successTitle: "Demande Envoyée !",
    successDesc: "Nous avons reçu vos coordonnées. Un spécialiste analysera votre demande et vous contactera dans les plus brefs délais.",
    btnGoHome: "Retour à la Page Principale",
    heroTitle: "Demander une Assistance Juridique",
    heroSubtitle: "Remplissez le formulaire ci-dessous pour nous fournir des détails sur votre situation. Un spécialiste vous contactera dans les plus brefs délais.",
    formSectionContact: "Coordonnées",
    formSectionCase: "Détails de l'Affaire",
    labelName: "Nom et Prénom",
    placeholderName: "Ex : Jean Dupont",
    labelEmail: "Adresse E-mail",
    placeholderEmail: "Ex : email@domaine.fr",
    labelPhone: "Numéro de Téléphone",
    placeholderPhone: "Ex : 07xxxxxxx",
    labelIsCompany: "Je suis une personne morale (entreprise)",
    labelIsRepresented: "Je suis déjà représenté(e) par un avocat",
    labelCounty: "Département",
    placeholderCounty: "-- Sélectionnez le Département --",
    descCounty: "Sélectionnez le département concerné par votre affaire.",
    labelPracticeArea: "Domaine de pratique",
    placeholderPracticeArea: "-- Sélectionnez le domaine de pratique --",
    labelDescription: "Décrivez votre situation de manière aussi détaillée que possible",
    placeholderDescription: "Écrivez les détails de votre affaire ici...",
    descDescription: "Fournissez le plus de détails possible pour permettre aux spécialistes de comprendre le contexte et de vous donner une première évaluation correcte.",
    agreementPart1: "Je suis d'accord avec les ",
    agreementTermsLink: "Conditions Générales",
    agreementPart2: " et la ",
    agreementPrivacyLink: "Politique relative aux cookies et Protection des données",
    agreementPart3: ".",
    btnSending: "Envoi en cours...",
    btnSubmit: "Envoyer la Demande",
    valRequiredName: "Le nom est obligatoire",
    valRequiredEmail: "L'e-mail est obligatoire",
    valInvalidEmail: "Adresse e-mail invalide",
    valRequiredPhone: "Le téléphone est obligatoire",
    valMinPhone: "Au moins 10 chiffres",
    valRequiredCounty: "Sélectionnez le département",
    valRequiredPracticeArea: "Sélectionnez le domaine de pratique",
    valRequiredDescription: "La description est obligatoire",
    valMinDescription: "Veuillez fournir plus de détails (minimum 20 caractères)",
    valRequiredTerms: "Vous devez accepter les conditions.",
    errorBannerTitle: "Erreur",
    errorGeneric: "Une erreur est survenue lors de l'envoi de la demande. Veuillez réessayer.",
    practiceCivil: "Droit Civil",
    practicePenal: "Droit Pénal",
    practiceComercial: "Droit Commercial",
    practiceFamiliei: "Droit de la Famille",
    practiceMuncii: "Droit du Travail",
    practiceAdministrativ: "Droit Administratif",
    practiceFiscal: "Droit Fiscal",
    practiceProprietate: "Droit de la Propriété Intellectuelle",
    practiceInsolventa: "Insolvabilité",
    practiceImobiliar: "Immobilier",
    practiceBancar: "Droit Bancaire",
    practiceAltul: "Autre"
  }
};

export default lawyerAssistanceTranslations;
